"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prevalidateFilesSuccess = exports.prevalidateFilesFailure = exports.prevalidateImportedFilesSuccess = exports.prevalidateImportedFilesFailure = void 0;
const rxjs_1 = require("rxjs");
const _Actions = require("../actions");
const prevalidateImportedFilesFailure = (namespace, error) => (0, rxjs_1.of)(_Actions.default(namespace).prevalidateImportedFilesFailure(error));
exports.prevalidateImportedFilesFailure = prevalidateImportedFilesFailure;
const prevalidateImportedFilesSuccess = (namespace, valid, files, reimportedUuids, colorMetaId) => (0, rxjs_1.of)(_Actions
    .default(namespace)
    .prevalidateImportedFilesSuccess(valid, files, reimportedUuids, colorMetaId));
exports.prevalidateImportedFilesSuccess = prevalidateImportedFilesSuccess;
const prevalidateFilesFailure = (namespace, error) => (0, rxjs_1.of)(_Actions.default(namespace).prevalidateFilesFailure(error));
exports.prevalidateFilesFailure = prevalidateFilesFailure;
const prevalidateFilesSuccess = (namespace, valid, files, reimportedUuids, colorMetaId) => (0, rxjs_1.of)(_Actions
    .default(namespace)
    .prevalidateFilesSuccess(valid, files, reimportedUuids, colorMetaId));
exports.prevalidateFilesSuccess = prevalidateFilesSuccess;
//# sourceMappingURL=filesValidationResponseHandlers.js.map